export const isSafeRedirectUrl = (url: string): boolean => {
  if (url.startsWith("/")) {
    return true;
  }
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

export const getPathFromURL = (url: string) => {
  if (url.startsWith("/")) {
    return url;
  }
  try {
    const urlObject = new URL(url);
    // Reject any scheme other than http/https (e.g. javascript:, data:, httpx:)
    if (urlObject.protocol !== "http:" && urlObject.protocol !== "https:") {
      return "/";
    }
    return `${urlObject.pathname}${urlObject.search}`;
  } catch {
    return "/";
  }
};
